import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { MMMRoute, getActiveRoute } from 'src/app/routes/utils';

export const useActiveRoute = () => {
  const location = useLocation();

  const [activeRoute, setActiveRoute] = useState<MMMRoute | null>();
  const [activeSubroute, setActiveSubroute] = useState<MMMRoute | null>();

  useEffect(() => {
    const newActiveRoute = getActiveRoute(location.pathname);
    if (newActiveRoute) {
      setActiveRoute(newActiveRoute);

      // Check if we're on a subroute
      if (newActiveRoute.subroutes) {
        const matchingSubroute = newActiveRoute.subroutes.find(
          (subroute) =>
            location.pathname === subroute.url ||
            location.pathname.startsWith(subroute.url + '/'),
        );
        setActiveSubroute(matchingSubroute || null);
      } else {
        setActiveSubroute(null);
      }
    } else {
      setActiveRoute(null);
      setActiveSubroute(null);
    }
  }, [location.pathname]);

  return { activeRoute, activeSubroute };
};
